import '@mantine/carousel/styles.css';
import './AvalContainer.css'
import { Avatar, Flex, Skeleton, Stack, Tooltip } from '@mantine/core';
// import AvalCarouselContainer from '../../../../components/AvalsCarousel/AvalCarouselContainer/AvalCarouselContainer';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

export default function AvalContainer() {
   const [avals, setAvals] = useState([])
   const [isLoading, setIsLoading] = useState(false)

   useEffect(() => {
      setIsLoading(true)
      const url = process.env.REACT_APP_BACKEND_SERVER + '/info/avals';
      axios.get(url)
         .then(response => setAvals(response.data))
         .catch(err => console.log(err))
         .finally(() => setIsLoading(false))
   }, [])

   return (
      <section className='avalContainer'>
         <div className='avalSection-container'>
            {isLoading &&
               <div className='skeleton-container'>
                  <Skeleton height={90} width={'auto'} circle />
                  <Skeleton height={90} width={'auto'} circle />
                  <Skeleton height={90} width={'auto'} circle />
                  <Skeleton height={90} width={'auto'} circle />
               </div>
            }
            {!isLoading && avals && <Stack>
               < AvalRows title={'Certifican'} avals={avals.filter(item => item.action === 'CERTIFICATE')} />
               < AvalRows title={'Avalan'} avals={avals.filter(item => item.action === 'AVAL')} />
               < AvalRows title={'Auspician'} avals={avals.filter(item => item.action === 'ADS')} />
            </Stack>}
         </div>
      </section>
   );
}


const AvalRows = ({ avals, title }) => {
   const [] = useState(false)
   return (
      <Stack>
         <h5 className='avalSection-title'>{title}</h5>
         <Flex
            px='var(--layout-padding-x)'
            wrap={'wrap'}
            justify='start'
            gap={16}
            w='100%'>
            {avals?.map(item => {
               return <AvalItem item={item} />
            })}
         </Flex>
      </Stack>
   )
}

const AvalItem = ({ item }) => {
   return <Tooltip label={item.name}>
      <Link
      key={item._id}
      to={item.web}
      target="_blank"
      className="home_avals__item"
   >
      <img
         src={item.image}
         alt={item.name}
         className="home_avals__image"
      />
   </Link>
   </Tooltip>
}